import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms'
import { AngularFireDatabase} from 'angularfire2/database';


@Component({
  selector: 'app-contact-me',
  templateUrl: './contact-me.component.html',
  styleUrls: ['./contact-me.component.css']
})
export class ContactMeComponent {
  
  userEmails;
  
  constructor(db: AngularFireDatabase) {
    this.userEmails = db.list('/userEmails');
  }

  @ViewChild('f') contactMeForm: NgForm
  onSubmit() {
    const { username, email, message } = this.contactMeForm.value;
    const date = Date();
    let formRequest = { username, email, message, date };
    console.log(formRequest);
    this.userEmails.push(formRequest);
    this.contactMeForm.reset();
  }
}



// WEBPACK FOOTER //
// /Users/Gabe/Desktop/AngularApps/GabesWebsitePublic/GabesWebsite/src/app/contact-me/contact-me.component.ts